module.exports = __webpack_public_path__ + "static/media/icon.6e94a8f5.png";